import React from 'react';
import { Html } from '@react-three/drei';
import { tokens } from '@fluentui/react-components';

// Constant-pixel-size arrowhead rendered as HTML — never grows on zoom.
// Shared by all dimension/gap overlays (room, furniture, clearance) so every
// measurement arrow in the configurator looks identical.
const ArrowHead = ({ position, dir, color = '#1e293b' }) => {
    const C = color;
    const S = 5, A = 8;
    const styles = {
        right: { borderTop: `${S}px solid transparent`, borderBottom: `${S}px solid transparent`, borderLeft: `${A}px solid ${C}` },
        left:  { borderTop: `${S}px solid transparent`, borderBottom: `${S}px solid transparent`, borderRight: `${A}px solid ${C}` },
        up:    { borderLeft: `${S}px solid transparent`, borderRight: `${S}px solid transparent`, borderBottom: `${A}px solid ${C}` },
        down:  { borderLeft: `${S}px solid transparent`, borderRight: `${S}px solid transparent`, borderTop: `${A}px solid ${C}` },
    };
    const isDot = !styles[dir];
    return (
        <group position={position}>
            <Html center>
                {isDot
                    ? <div style={{ width: 6, height: 6, background: C, borderRadius: tokens.borderRadiusCircular, margin: '-3px', pointerEvents: 'none' }} />
                    : <div style={{ width: 0, height: 0, ...styles[dir], pointerEvents: 'none' }} />
                }
            </Html>
        </group>
    );
};

// Two arrowheads pointing straight at each other, guaranteed to meet tip-to-tip —
// used where a solid dimension line hands off to a dashed one at the same point
// (e.g. "Baldo matmenys" ending exactly where "Laisvumo tarpeliai" begins). Two
// independently <Html center>-ed ArrowHead's can drift a few px apart depending on
// each one's own centering math; laying both triangles out as adjacent flex
// children (zero gap, no margins) makes them touch by CSS flow instead, which is
// exact regardless of that math.
export const MeetingArrows = ({ position, orientation = 'horizontal', color = '#1e293b' }) => {
    const C = color;
    const S = 5, A = 8;
    const isH = orientation === 'horizontal';
    // "Nosys" susiliečia viduryje: horizontaliai — kairioji rodyklė žiūri į dešinę,
    // dešinioji į kairę; vertikaliai — viršutinė žiūri žemyn, apatinė į viršų.
    const first  = isH
        ? { borderTop: `${S}px solid transparent`, borderBottom: `${S}px solid transparent`, borderLeft: `${A}px solid ${C}` }
        : { borderLeft: `${S}px solid transparent`, borderRight: `${S}px solid transparent`, borderTop: `${A}px solid ${C}` };
    const second = isH
        ? { borderTop: `${S}px solid transparent`, borderBottom: `${S}px solid transparent`, borderRight: `${A}px solid ${C}` }
        : { borderLeft: `${S}px solid transparent`, borderRight: `${S}px solid transparent`, borderBottom: `${A}px solid ${C}` };
    return (
        <group position={position}>
            <Html center>
                <div style={{ display: 'flex', flexDirection: isH ? 'row' : 'column', alignItems: 'center', pointerEvents: 'none' }}>
                    <div style={{ width: 0, height: 0, ...first }} />
                    <div style={{ width: 0, height: 0, ...second }} />
                </div>
            </Html>
        </group>
    );
};

export default ArrowHead;
